import { initialStateData } from '../Base';
import { AppletSchema } from './Applet.schema';

export const state: AppletSchema = {
  applet: initialStateData,
};
